module.exports = {
    textSearchPlaceholder: {
        en: "Text search here",
        fi: "Tekstihaku tänne"
    },
    status: {
        en : "Status", 
        fi: "Tila"
    },
    selling: {
        en: "Selling",
        fi: "Myydään"
    },
    sold: {
        en: "Sold",
        fi: "Myyty"
    },
    province: {
        en: "Province",
        fi: "Maakunta"
    },
    city: {
        en: "City",
        fi: "Kaupunki"
    },
    minPrice: {
        en: "Minimum price €",
        fi: "Minimihinta €"
    },
    maxPrice: {
        en: "Maximum price €",
        fi: "Maksimihinta €"
    },
    search: {
        en: "Search",
        fi: "Hae"
    },
    selectACondition: {
        en: "Select a condition",
        fi: "Valitse kuntotaso"
    },
    selectAConditionToolTip: {
        en: "Condition is required",
        fi: "Kuntotaso on pakollinen"
    },
};